import lazyScripts from "../services/lazy-scripts";
import interact from "../services/interact";

/**
 * @param props
 */

export default (props) => {
    return {
        videoElement: null,
        mediaUrl: null,
        targetUrl: null,
        visible: false,
        started: false,
        finished: false,
        vast: {
            client: false,
            tracker: false,
            source: null,
        },
        progress: 0,
        skip: {
            visible: false,
            remain: 5,
            delay: 5,
        },
        tracking: props.tracking,
        label: props.label,
        mounted() {
            this.videoElement = this.$refs.video;
            interact.event((o) => {
                this.events();
                this.prepare();
            });
        },
        prepare() {
            lazyScripts.loadVast().then(() => {
                this.vast.client = new VAST.VASTClient();
                this.vast.client.get(this.service[this.label].vast).then(res => {
                    if (res.hasOwnProperty('ads') && res.ads.length !== 0) {
                        this.vast.tracker = new VAST.VASTTracker(this.vast.client, res.ads[0], res.ads[0].creatives[0]);
                        this.vast.tracker.load();
                        this.vast.tracker.trackImpression();

                        this.mediaUrl = res.ads[0].creatives[0].mediaFiles[0].fileURL;

                        this.targetUrl = res.ads[0].creatives[0].videoClickThroughURLTemplate.url;

                        setTimeout(() => {
                            this.videoElement.muted = true;
                            this.videoElement.volume = 0;
                            this.videoElement.load();
                            this.videoElement.play();
                        }, 50 );
                        if ( this.tracking ) {
                            fetch(this.service[this.label].track + '?label=normal').then();
                        }
                    } else {
                        if ( this.tracking ) {
                            fetch(this.service[this.label].track + '?label=empty').then();
                        }
                    }
                });
            });
        },
        dismiss() {
            if ( typeof this.service[this.label].close !== "undefined") {
                fetch(this.service[this.label].close).then(() => {});
            }
            this.vast.tracker.track('skip');
            this.videoElement.pause();
            this.visible = false;
        },
        click() {
            this.vast.tracker.track('clickthrough');
        },
        events() {

            this.videoElement.addEventListener('canplay', () => {
                this.visible = true;
            });

            // this.videoElement.addEventListener('error', () => {
            //     console.log("error");
            // });

            this.videoElement.addEventListener('timeupdate', () => {
                this.started = true;
                this.progress = parseInt(this.videoElement.currentTime / this.videoElement.duration * 100);
                if ( this.videoElement.currentTime >= this.skip.delay && !this.skip.visible) {
                    this.skip.visible = true;
                    return false;
                }
                if (!this.skip.visible ) {
                    this.skip.remain = this.skip.delay - parseInt(this.videoElement.currentTime);
                    return false;
                }
            });

            this.videoElement.addEventListener('ended', () => {
                this.videoElement.pause = true;
                this.finished = true;
            });

        }

    }
};